import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import T from 'prop-types';
// utils
import { useSelector } from 'react-redux';
import { OVERVIEW_FULL, EXTERNAL_FULL, getTicketRoute } from 'routes';
// components
import Typography from 'components/Typography';
// icons
import { ReactComponent as ChevronIcon } from 'icons/chevron.svg';
import { ReactComponent as ExternalLinkIcon } from 'icons/external-link.svg';
// styles
import classnames from 'classnames/bind';
import styles from './MissionSidebar.module.scss';

const cx = classnames.bind(styles);

const MissionSidebar = ({ isOpen }) => {
  const [exitMenuOpen, setExitMenuOpen] = useState(true);
  const {
    exitTickets = [],
    number: missionNumber = '',
    title: missionTitle,
  } = useSelector(({ classroom: { currentMission = {} } }) => {
    const exitTickets = (currentMission?.parts || []).filter(({ assessment }) => !!assessment);

    return { ...currentMission, exitTickets };
  });

  const toggleExitMenu = () => setExitMenuOpen((prev) => !prev);
  const activitiesLinks = [
    '/',
    '/',
    '/',
    '/teach/city-of-immigrants-alt/teach-this-mission/implementation-guide/',
    '/teach/up-from-the-dust/teaching-this-mission/curriculum-overview-chart/',
  ];

  return (
    <section className={cx('container', { hidden: !isOpen })}>
      <div className={cx('wrapper')}>
        <div className={cx('header')}>
          <Typography type="body-xs">{`MISSION ${missionNumber}:`}</Typography>
          <Typography>{missionTitle}</Typography>
        </div>
        <div className={cx('menu-options')}>
          <a className={cx('option')} href={missionNumber && activitiesLinks[missionNumber - 1]}>
            <Typography type="body-s">{`Discussion & Activities`}</Typography>
            <ExternalLinkIcon />
          </a>
          <NavLink
            className={cx('option')}
            to={OVERVIEW_FULL}
            style={({ isActive }) => ({ backgroundColor: isActive && '#f3f3f5' })}
          >
            <Typography type="body-s">Class Overview</Typography>
          </NavLink>
          <div className={cx('option', 'clickable-text')} onClick={toggleExitMenu}>
            <Typography type="body-s">Exit Ticket Assessments</Typography>
            <ChevronIcon className={cx('chevron', { closed: !exitMenuOpen })} />
          </div>
          <div className={cx('exit-menu')}>
            <ul className={cx('menu-list', { closed: !exitMenuOpen })}>
              {exitTickets.map(({ title, id }) => (
                <li key={title} className={cx('clickable-text')}>
                  <NavLink
                    className={cx('option')}
                    to={getTicketRoute(id)}
                    style={({ isActive }) => ({ backgroundColor: isActive && '#f3f3f5' })}
                    replace
                  >
                    <span className={cx('cdot', 'mgh-10')}>·</span>
                    <Typography title={title.slice(3)} className={cx('ticket-label', 'mgr-auto')} type="body-s">
                      {title.slice(3)}
                    </Typography>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

MissionSidebar.propTypes = {
  isOpen: T.bool.isRequired,
};

export default MissionSidebar;
